import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaperAirplane = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.51282 1.95944C1.92558 1.59581 2.51545 1.51346 3.01202 1.75013L22.347 10.9654C22.746 11.1555 23 11.5581 23 12C23 12.4419 22.746 12.8445 22.347 13.0346L3.01202 22.2498C2.51545 22.4865 1.92558 22.4042 1.51282 22.0405C1.15843 21.7283 0.989257 21.256 1.06486 20.7898L2.49023 12L1.06486 3.21019C0.989257 2.74399 1.15843 2.27164 1.51282 1.95944ZM3.8882 12.75L2.58407 20.7922L21.0314 12L2.58407 3.20782L3.8882 11.25H11.25C11.6642 11.25 12 11.5858 12 12C12 12.4142 11.6642 12.75 11.25 12.75H3.8882Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgPaperAirplane;
